<mat-form-field appearance="outline" class="cp-field" subscriptSizing="dynamic">
    <mat-label>{{ effectiveLabel() }}</mat-label>
    <input matInput [formControl]="inputControl" [matAutocomplete]="cpAuto"
           [placeholder]="placeholder" [required]="required" />

    @if (loading) {
        <mat-icon matSuffix class="cp-spin">hourglass_empty</mat-icon>
    } @else if (inputControl.value) {
        <button matSuffix mat-icon-button type="button" (click)="onClear()" aria-label="Clear connection">
            <mat-icon>close</mat-icon>
        </button>
    }

    <mat-autocomplete #cpAuto="matAutocomplete" [displayWith]="displayFn"
                      (optionSelected)="onOptionSelected($event)">
        @for (c of filtered; track c.connectionId) {
            <mat-option [value]="c.connectionId">
                <span class="cp-name">{{ c.name }}</span>
                <span class="cp-meta">
                    {{ c.type }}:{{ c.subtype }}@if (c.leaseable) { · leaseable }@if (c.enabled === false) { · disabled }
                </span>
            </mat-option>
        }
        @if (!loading && filtered.length === 0) {
            <mat-option disabled>No connections of this type</mat-option>
        }
    </mat-autocomplete>

    @if (loadError) { <mat-hint class="cp-error">{{ loadError }}</mat-hint> }
    @if (required && inputControl.hasError('required')) { <mat-error>Required</mat-error> }
</mat-form-field>
